/**
 * IconPicker constants
 */

// Color palette - 'inherit' means use node's category color
export const ICON_COLORS = [
  'inherit', // First option = match category color
  '#9ca3af', '#ef4444', '#f97316', '#eab308', '#22c55e', 
  '#14b8a6', '#3b82f6', '#6366f1', '#a855f7', '#ec4899'
];

// LocalStorage keys for recent items
export const RECENT_EMOJIS_KEY = 'plet_recent_emojis';
export const RECENT_ICONS_KEY = 'plet_recent_icons';
export const MAX_RECENT = 24; // 3 rows of 8

